module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section2-498.dc8bfb36.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/section2-498.dc8bfb36.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/section2-498.dc8bfb36.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section2-498.dc8bfb36.webp"},
        
        width: 498,
        height: 498
      }